import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageZaragoza = props => {
  return <CityLandingPage cityKey="Zaragoza" cityConfig={cityContent.zaragoza} {...props} />;
};

export default LandingPageZaragoza;
